import { z } from "zod";
import { ActorRefSchema, TimestampSchema } from "./common.js";
import { EntityStateSchema, TransformSchema } from "./entity.js";
import { IdSchema, NamespacedNameSchema, TypeNameSchema } from "./ids.js";
/** How to compensate an event. Undo appends an event of this type and payload. */
export const EventInverseSchema = z.object({
    type: NamespacedNameSchema,
    payload: z.record(z.string(), z.unknown()),
});
/** One row of the append-only event log (DESIGN §3). */
export const DomainEventSchema = z.object({
    /** Gap-free, strictly increasing per database. */
    seq: z.number().int().positive(),
    id: IdSchema,
    at: TimestampSchema,
    companyId: IdSchema.nullable(),
    actor: ActorRefSchema,
    /** The human this was done for (agents always act for a human). */
    onBehalfOf: IdSchema.nullable(),
    taskId: IdSchema.nullable(),
    type: NamespacedNameSchema,
    entityId: IdSchema.nullable(),
    /** Entity version after this event, for entity events; used for undo conflict checks. */
    entityVersion: z.number().int().positive().nullable(),
    payload: z.record(z.string(), z.unknown()),
    inverse: EventInverseSchema.nullable(),
    /** Set on compensating events: the id of the event this one undoes. */
    compensates: IdSchema.nullable(),
    causationId: IdSchema.nullable(),
    correlationId: IdSchema,
});
/** Core entity event types and their payloads. Projections are derived from these. */
export const ENTITY_EVENTS = {
    created: "entity.created",
    updated: "entity.updated",
    deleted: "entity.deleted",
    restored: "entity.restored",
};
export const EntityCreatedPayloadSchema = z.object({
    type: TypeNameSchema,
    parentId: IdSchema.nullable(),
    props: z.record(z.string(), z.unknown()),
    transform: TransformSchema.nullable(),
});
export const EntityUpdatedPayloadSchema = z.object({
    before: EntityStateSchema,
    after: EntityStateSchema,
});
export const EntityDeletedPayloadSchema = z.object({});
export const EntityRestoredPayloadSchema = z.object({});
/** Notification published after a projection changes (realtime `entity.changed`). */
export const EntityChangeSchema = z.object({
    seq: z.number().int().positive(),
    entityId: IdSchema,
    companyId: IdSchema.nullable(),
    type: TypeNameSchema,
    version: z.number().int().positive(),
    deleted: z.boolean(),
});
export const UndoConflictSchema = z.object({
    eventId: IdSchema,
    entityId: IdSchema.nullable(),
    reason: z.enum(["entity_changed", "not_undoable", "already_undone", "not_found"]),
});
//# sourceMappingURL=events.js.map